import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '../../../components/sharedComponents/Drawer';
import { IconHelp, IconAnnouncement } from '../../sharedComponents/icons/Icons';
import SearchInputContainer from '../../../containers/navigation/SearchInputContainer';
import SignInOrAccountPanel from './SignInOrAccountPanel';
import useProfilePicture from './useProfilePicture';

const searchInputQueryParam = 'headerTextQuery';

export default function MobileMenu({
    isOpen,
    onClose,
    triggerId = 'mobile-menu-toggle-btn',
    logout,
}) {
    const profilePicture = useProfilePicture();

    return (
        <Drawer
            label="Mobile menu"
            isLabelVisible={false}
            isOpen={isOpen}
            onClose={onClose}
            triggerId={triggerId}
            direction="right"
            appearance="dark"
            hasRecLogo
        >
            <div className="nav-mobile-menu-body">
                <SearchInputContainer
                    ariaLabel="Mobile menu search"
                    queryCriteriaPropertyName={searchInputQueryParam}
                    searchInputID="mobile-menu-search-input"
                />

                <SignInOrAccountPanel
                    logout={logout}
                    profilePicture={profilePicture} />

                <a
                    className="nav-mobile-menu-row"
                    href="https://recreationonestopprod.servicenowservices.com/external"
                    aria-label="Help"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Help
                    <span className="nav-mobile-menu-row-icon">
                        <IconHelp />
                    </span>
                </a>

                <a
                    className="nav-mobile-menu-row"
                    href="/whats-new"
                    aria-label="What's New on Recreation.gov"
                >
                    What&#39;s New
                    <span className="nav-mobile-menu-row-icon">
                        <IconAnnouncement />
                    </span>
                </a>
            </div>
        </Drawer>
    );
}

MobileMenu.propTypes = {
    isOpen: PropTypes.bool,
    triggerId: PropTypes.string,
    onClose: PropTypes.func,
    logout: PropTypes.func,
};
